import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/auth-store'
import { supabase } from '@/lib/supabase/client'
import { useEffect } from 'react'

export function useAuth() {
  const navigate = useNavigate()
  const { user, setUser } = useAuthStore()

  // Sincroniza o estado com a sessão do Supabase
  useEffect(() => {
    // Recupera a sessão inicial
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
    })

    // Escuta mudanças na autenticação
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
    })

    return () => subscription.unsubscribe()
  }, [])

  const login = async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })

    if (error) throw error

    setUser(data.user)
    navigate('/')
  }

  const register = async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    })

    if (error) throw error

    setUser(data.user)
    navigate('/')
  }

  const logout = async () => {
    try {
      // Primeiro, faz logout no Supabase
      const { error } = await supabase.auth.signOut()
      if (error) throw error

      // Limpa o estado do usuário
      setUser(null)

      // Redireciona para o login
      navigate('/login', { replace: true })
    } catch (error) {
      console.error('Erro ao fazer logout:', error)
      throw error
    }
  }

  return {
    user,
    login,
    logout,
    register,
  }
} 